import { defineComponent } from "vue";
import { processMediaItem } from "@i22/rocket";
import ImageElement from "./component-library8.mjs";
import PictureElement from "./component-library9.mjs";
const getFiltersProps = (props, blacklist) => {
  const filteredProps = {};
  Object.keys(props).forEach((propName) => {
    if (blacklist.includes(propName))
      return;
    filteredProps[propName] = props[propName];
  });
  return filteredProps;
};
const getUrl = (path) => {
  if (!path)
    return void 0;
  return path.replace(/\/public\//, "/product-images/");
};
const getImagesByWidth = (image, targetSize = "medium") => {
  let localImage = image;
  if (image.mediaId && !image.medium) {
    localImage = processMediaItem(image);
  }
  switch (targetSize) {
    case "small":
      return getUrl(localImage.small);
    case "medium":
      return getUrl(localImage.medium);
    default:
      return getUrl(localImage.large);
  }
};
const _sfc_main = defineComponent({
  name: "GoliathImageElement",
  components: {
    PictureElement,
    ImageElement
  },
  props: {
    ...getFiltersProps(ImageElement.props, [
      "src",
      "srcSm",
      "srcMd",
      "srcLg",
      "srcXl",
      "renderWithoutFigure"
    ]),
    image: { type: Object, required: true },
    alt: { type: String, default: "" },
    xsWidth: { type: String, default: "medium" },
    smWidth: { type: String, default: "large" },
    lazy: { type: Boolean },
    renderWithoutFigure: { type: Boolean },
    sizes: {
      type: String,
      // "sm:100vw md:50vw lg:400px" https://v0.image.nuxtjs.org/components/nuxt-img#sizes
      default: ""
    }
  },
  emits: ["image-error"],
  computed: {
    passThroughProps() {
      return getFiltersProps(this.$props, [
        "src",
        "renderWithoutFigure",
        "image",
        "xsWidth",
        "smWidth"
      ]);
    },
    src() {
      if (!this.image || this.image.remote)
        return void 0;
      if (this.sizes) {
        return getImagesByWidth(this.image, "large");
      }
      return getImagesByWidth(this.image, this.xsWidth);
    },
    srcSm() {
      if (!this.image || this.sizes || this.image.remote)
        return void 0;
      return getImagesByWidth(this.image, this.smWidth);
    }
  }
});
export {
  _sfc_main as default
};
